import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import moment from 'moment';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

export const ChatContent = ({ filter, chatContent }) => {
  if (!chatContent) {
    return null;
  }

  const { t } = useTranslation();

  const content = filter ? chatContent.filter(filter) : chatContent;

  if (!content || content.length === 0) {
    return (
      <Box>
        <Trans i18nKey="chat.noContent" />
      </Box>
    );
  }

  const renderTime = (timestamp, timestampFormat) => {
    return moment(timestamp).format(timestampFormat);
  };

  const timestampFormat = t('common.timestampFormat');

  let sideCounter = 0;
  let lastMessageSender = content[0].from;
  let skipDisplayingLastMessageTime = false;

  return (
    <Box className="autoscroll-container">
      {content.map((msg, index) => {
        if (lastMessageSender != msg.from) {
          sideCounter++;
          skipDisplayingLastMessageTime = false;
        } else if (index > 0) {
          skipDisplayingLastMessageTime = true;
        }

        const align = sideCounter % 2 == 0 ? 'start' : 'end';

        lastMessageSender = msg.from;

        return (
          <Box align={align} key={'chat-content-' + index}>
            {!skipDisplayingLastMessageTime && (
              <Text fontSize="xs">
                {msg.from} {renderTime(msg.timestamp, timestampFormat)}
              </Text>
            )}
            <Box>
              <Button
                borderRadius={32}
                as="text"
                bg="brand.120"
                _hover={undefined}
                _active={undefined}
              >
                {msg.content}
              </Button>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

ChatContent.propTypes = {
  filter: PropTypes.func,
  chatContent: PropTypes.array,
  scrollRef: PropTypes.object,
};
